import { Qualifier } from "../../graphql";

const qualifierHash = (q: Qualifier) =>
  `${q.relation?.id}_${q.value?.id}_${q.negate}`;

export function dedupQualifiers(qualifiers: Qualifier[]) {
  //dedup while keeping order
  const ret = [];
  const qualifiersIds = new Set<String>();

  qualifiers.forEach((q) => {
    const hash = qualifierHash(q);
    if (!qualifiersIds.has(hash)) {
      ret.push(q);
      qualifiersIds.add(hash);
    }
  });

  return ret;
}
